/** "Nice" round scale-bar lengths (m) to choose from. */
const NICE_SCALE_STEPS = [
  1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000,
];

/** Largest nice length (m) whose on-screen width stays under `maxPx`. */
export function pickNiceScale(metersPerPixel: number, maxPx = 140): number {
  if (!(metersPerPixel > 0)) return NICE_SCALE_STEPS[0]!;
  let chosen = NICE_SCALE_STEPS[0]!;
  for (const step of NICE_SCALE_STEPS) {
    if (step / metersPerPixel <= maxPx) chosen = step;
    else break;
  }
  return chosen;
}
